import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class FlashIcon extends AbstractIcon {
  static selector = "flash-icon"

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path d="M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z"/>
      </svg>
`;
  }
}

componentsRegistryService.define(FlashIcon);